import { map } from 'rxjs/operators';
import { LovValues, TemplateFieldsDisplayFn } from '../../../../../models/template.model';
import { Dash, displayFnWrapper } from '../../../utils/dynamic-data-retrievers';
import { currencyLov, PropertyType, propertyTypeDisplayFnFactory, valueWithUomPrefix } from '../us.common';
import {
  US_PROPERTY_COMMON_BODY_FIELDS,
  US_PROPERTY_COMMON_FOOTER_FIELDS,
  US_PROPERTY_COMMON_HEADER_FIELDS,
  filterUsagesByPropertyType,
  mapFormatAndFilterValues,
} from './us-property.common';
import { ReportRecord } from '../../../../../models/report.model';
import { concatValuesBy } from '@miq/utils';

const officeDisplayFnWrapper = propertyTypeDisplayFnFactory(PropertyType.Office);

export const displayFnMap: TemplateFieldsDisplayFn = {
  ...US_PROPERTY_COMMON_HEADER_FIELDS,

  50: {
    displayFn: (record: ReportRecord, _, market, submarket, district, neighborhood) => {
      const recordWithOfficeUsages = filterUsagesByPropertyType(record, PropertyType.Office);
      const locationValues = mapFormatAndFilterValues(
        recordWithOfficeUsages,
        [market, submarket, district, neighborhood],
        Dash
      );
      return concatValuesBy(' - ', ...locationValues);
    },
  }, // 50 - Location

  133: { displayFn: displayFnWrapper }, // 133 - Site Size
  ...US_PROPERTY_COMMON_BODY_FIELDS(PropertyType.Office),
  ...US_PROPERTY_COMMON_FOOTER_FIELDS(PropertyType.Office),
  163: { displayFn: officeDisplayFnWrapper }, // 163 - Full Floor Available
  164: { displayFn: officeDisplayFnWrapper }, // 164 - Class
  165: { displayFn: displayFnWrapper }, // 165 - Floors
  166: { displayFn: displayFnWrapper }, // 166 - Min SF/Floor
  167: { displayFn: displayFnWrapper }, // 167 - Elevators: Passenger
  168: { displayFn: displayFnWrapper }, // 168 - Elevators: Freight
  169: { displayFn: officeDisplayFnWrapper }, // 169 - Parking: Type
  142: {
    displayFn: (record: ReportRecord, options, arg) => {
      return currencyLov(options).pipe(
        map((currencyLOV: LovValues[]) => {
          const TIAVal = valueWithUomPrefix(record, PropertyType.Office, arg, currencyLOV);
          return TIAVal;
        })
      );
    },
  }, // 142 - Tis
};
